import { useEffect, useState } from 'react';

import { Container } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { modelApis } from '../../../apis/modelApis';
import AlertMessage from '../../../components/elements/alert-message/AlertMessage';
import Loading from '../../../components/elements/loading/Loading';
import Title from '../../../components/elements/title/Title';
import Breadcrumbs from '../../../components/sections/breadcrumbs/Breadcrumbs';
import List from '../../../components/sections/list/List';

const ProjectModelListPage = () => {
  const { projectId } = useParams();
  const { t } = useTranslation();

  const [modelList, setModelList] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const { data: modelRes } = await modelApis.getModels(projectId);
      setModelList(modelRes.content);
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Container>
      {loading ? (
        <Loading />
      ) : error ? (
        <AlertMessage
          severity="error"
          message={t('fetchModelError', { ns: 'notifications' })}
        />
      ) : (
        <section>
          <Breadcrumbs />
          <Title text={t('models', { ns: 'model' })} />
          <List data={modelList} />
        </section>
      )}
    </Container>
  );
};

export default ProjectModelListPage;
